import {Injectable, Signal, computed, signal} from "@angular/core";

@Injectable()
export class TrainContainersValidity {
  private readonly rows = signal<ReadonlyMap<object, Signal<boolean>>>(new Map());

  readonly valid = computed(() => [...this.rows().values()].every((rowValid) => rowValid()));

  register(row: object, valid: Signal<boolean>): void {
    this.rows.update((rows) => new Map(rows).set(row, valid));
  }

  unregister(row: object): void {
    this.rows.update((rows) => {
      const next = new Map(rows);
      next.delete(row);
      return next;
    });
  }
}
